import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

import useAxios from '../../../../Hooks/use-axios';

const useData = (eventId) => {
    const [event, setEvent] = useState('');
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const { isLoading, error, sendRequest: fetchEventDetails } = useAxios();

    const getEventDetails = () => {
        let url = `/cms_service/events/${eventId}`;
        let method = 'get';
        fetchEventDetails(
            {
                isEncryptedResponse: false,
                url,
                method
            },
            (data) => {
                // console.log('Event Details', data);
                setEvent(data);
            }
        );
    };

    useEffect(() => {
        getEventDetails();
    }, [eventId]);

    return {
        event,
        isLoading
    };
};

export default useData;
